import type { RootState } from '..';
import { createStringContentSlice } from './helpers/slice_helpers';

const nextCareerSlice = createStringContentSlice({ name: 'nextCareer' });

export const { setContent: updateNextCareer } = nextCareerSlice.actions;

export const selectNextCareer = (state: RootState) => state.nextCareer.content;

export default nextCareerSlice.reducer;
